export enum ResponseStatusEnum {
    badRequest = 400,
    created = 201,
    forbidden = 403,
    unauthorized = 401,
    internalServerError = 500,
    notFound = 404,
    ok = 200,
}
